export default __webpack_public_path__ + "static/product-listing-management-73efcc74c981419f49d5c87478a9d5fc.png";